import { Storage } from "@/firebase/index";
const pdf2base64 = require("pdf-to-base64");
import firebase from "firebase";

export default {
  storageRef(path) {
    return firebase.storage().ref(path);
  },

  tipoDocumentoRef() {
    return firebase.firestore().collection("perfil_tipo_documento");
  },

  async getTipoDocumentos() {
    const snapshot = await this.tipoDocumentoRef()
      .orderBy("nome", "asc")
      .get();
    return snapshot.docs.map(e => ({
      ...e.data(),
      id: e.id
    }));
  },

  async getUserDocuments(storage, user) {
    const investorDocumentAttachs = this.storageRef(storage);

    const response = await investorDocumentAttachs.child(user).listAll();

    return response;
  },

  async base64Attachment(file, storage = "Standard") {
    const operationalAttachments = this.storageRef(storage);

    return await operationalAttachments
      .child(file)
      .getDownloadURL()
      .then(async function(url) {
        return await pdf2base64(url)
          .then(response => {
            return response;
          })
          .catch(error => {
            console.log(error);
          });
      });
  },

  async downloadAttachment(file, storage = "Standard", type = undefined) {
    const operationalAttachments = this.storageRef(storage);

    operationalAttachments
      .child(file)
      .getDownloadURL()
      .then(function(url) {
        const xhr = new XMLHttpRequest();
        xhr.responseType = "blob";
        xhr.onload = function() {
          const a = document.createElement("a");

          a.href = window.URL.createObjectURL(xhr.response);
          a.download = file;
          if (type) {
            a.download = file + type;
          }
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
        };
        xhr.open("GET", url);
        xhr.send();
      });
  },

  async addNewDocumentAttachment(attachment, fileName, storage, user) {
    const operationalAttachment = this.storageRef(storage);

    const fileNameAdjusted = fileName.replace(/\//g, "_");

    const response = await operationalAttachment
      .child(user)
      .child(fileNameAdjusted)
      .put(attachment);

    return response;
  },

  async deleteAttachment(file, storage = "Standard", user = undefined) {
    const operationalAttachments = this.storageRef(storage);

    if (user) {
      await operationalAttachments
        .child(user)
        .child(file)
        .delete();
    } else {
      await operationalAttachments.child(file).delete();
    }
  },

  async getTermsAttachments(storage = "InvestmentTerms") {
    const storageEnvironment = Storage.ref(storage);

    const response = await storageEnvironment.listAll();

    return response;
  },

  async urlAttachment(file, storage = "InvestmentTerms") {
    var urlAtt = "";
    const storageEnvironment = Storage.ref(storage);
    await storageEnvironment
      .child(file)
      .getDownloadURL()
      .then(function(url) {
        urlAtt = url;
      });

    return urlAtt;
  },

  async addNewAttachment(attachment, fileName, storage = "Standard") {
    const storageRef = this.storageRef(storage);

    const fileNameAdjusted = fileName.replace(/\//g, "_");
    const response = await storageRef
      .child(fileNameAdjusted)
      .putString(attachment, "data_url");

    return response;
  }
};
